export const links = [
    {
        title: "retoucher",
        text: "Image Background Remover",
        href: "/",
        event: "retoucher",
    },
    {
        title: "resizer",
        text: "Image Resizer",
        href: "/image-resizer",
        event: "resizer",
    },
    {
        title: "rotator",
        text: "Image Rotator",
        href: "/image-rotator",
        event: "rotator",
    },

    {
        title: "flipper",
        text: "Image Flipper",
        href: "/image-flipper",
        event: "flipper",
    },

    {
        title: "cropper",
        text: "Image Cropper",
        href: "/image-cropper",
        event: "cropper",
    },
];

export const year = new Date().getFullYear();
